import React from "react";
import "./styles.css"


export const WagonTableHeader = ({ header }) => {
  return (
    <th className="py-0">
      {header}
    </th>
  );
}
